export const correspondingXYZ = {
  UP: '-z',
  DOWN: 'z',
  W: '-y',
  E: 'y',
  S: '-x',
  N: 'x',
};
